var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEthIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13397_124730)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9984 0L11.8374 0.546928V16.4161L11.9984 16.5767L19.3646 12.2225L11.9984 0Z",
    fill: "#343434"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9982 0L4.63184 12.2225L11.9982 16.5767V8.87428V0Z",
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9985 17.9691L11.9077 18.0798V23.7326L11.9985 23.9975L19.3691 13.6172L11.9985 17.9691Z",
    fill: "#3C3C3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9982 23.9975V17.9691L4.63184 13.6172L11.9982 23.9975Z",
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9985 16.5794L19.3647 12.2252L11.9985 8.87695V16.5794Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.63184 12.2252L11.9982 16.5794V8.87695L4.63184 12.2252Z",
    fill: "#393939"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13397_124730"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthIcon);
export default __webpack_public_path__ + "static/media/eth_icon.f18923ce51276e25d6265f71f748af31.svg";
export { ForwardRef as ReactComponent };